import { createRelationships as _createRelationships } from '@griply/services';
import { MinimalRelationship } from '@griply/types';
import {
  collection,
  doc,
  serverTimestamp,
  setDoc,
  writeBatch,
} from 'firebase/firestore';

import { getAuthentication, getDatabase } from './helpers';

export const createRelationships = async (
  relationships: MinimalRelationship[],
) => {
  const user = (await getAuthentication()).currentUser;

  if (!user) {
    throw Error('unauthenticated');
  }

  await _createRelationships({
    relationships,
    userId: user.uid,
    collection,
    doc,
    setDoc,
    db: getDatabase(),
    serverTimestamp,
    writeBatch,
  });
};
